//@ts-ignore
import { parse as parseUntyped, stringify as stringifyUntyped } from 'query-string'

// somehow type declaration is broken for 'query-string'
// we re-export methods with our own types

type Parse = (input: string) => Record<string, string | string[] | undefined>
type Stringify = (input: object) => string

export const parse: Parse = parseUntyped as any
export const stringify: Stringify = stringifyUntyped

export const pickQueries = (queries: Record<string, string | string[] | undefined>) => (key: string) => {
  const pVal = queries[key]
  return pVal && pVal instanceof Array ? pVal[0] : pVal
}
